import * as React from 'react';

import { ProjectModel } from 'franke-trough-dependencies';
import { Icon } from 'src/app/Partials';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import './ProjectListItem.scss';

import { FormattedMessage } from 'react-intl';
import MESSAGES from './ProjectListItem.messages';
import { formatMessage, getCountryNameByCode } from 'src/api';

export interface ProjectListItemProps {
  projects: ProjectModel;
  showSettings: boolean;
  onShowSettings?: (id?: string) => void;
}

export class ProjectListItem extends React.Component<ProjectListItemProps> {
  constructor(props: ProjectListItemProps) {
    super(props);
    this.state = {
      showSettings: false,
    };
    this.handleClick = this.handleClick.bind(this);
  }

  public render() {
    const { projects, showSettings } = this.props;
    const {  } = this.state;
    
    return (
      <div className={`partial-project-list-item w-100 p-4 ${showSettings ? 'show-settings' : ''}`}>
        <div className="square square-configuration w-100 h-100 d-flex flex-wrap">
          <div className="square-toggle position-absolute">
            <a 
              href="/settings"
              title={formatMessage({...MESSAGES.projectListItemLinkTitle})}
              onClick={this.handleClick}
            >
              {!showSettings ? (
                <Icon name="settings" size="small" />
              ) : (
                <Icon name="close" size="small" />
              )}
            </a>
          </div>
          <div className="square-inner inner">
            {!showSettings ? (
              <ul className="list-unstyled">
                <li>{projects.name}</li>
                {!projects.street && !projects.streetNr ? (
                  <></>
                ) : (
                  <li>{projects.street}, {projects.streetNr}</li>
                )}
                {!projects.zip && !projects.city && !projects.country ? (
                  <></>
                ) : (
                  <li>{projects.zip} {projects.city}, {getCountryNameByCode(projects.country)}</li>
                )}
              </ul>
            ) : (
              <div className="square-inner edit-icons">
                <Link to={`/profile/projects/${projects.id}/edit`}>
                  <Icon name="rename" size="small" />
                  <small><FormattedMessage {...MESSAGES.projectListItemEdit} /></small>
                </Link>
                {/* <Link to={`/profile/projects/${projects.id}/duplicate`} className="ml-3 mr-3 mb-4 pt-4 rounded-circle"><Icon name="add-file" size="small" /></Link> */}
                <Link to={`/profile/projects/${projects.id}/delete`}>
                <Icon name="delete" size="small" />
                  <small><FormattedMessage {...MESSAGES.projectListItemDelete} /></small>
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  private handleClick(event: React.MouseEvent) {
    event.preventDefault();
    if (this.props.onShowSettings) {
      this.props.onShowSettings(!this.props.showSettings ? this.props.projects.id : undefined);
    }
  }
}

export default ProjectListItem;
